import { type GetHookResponse } from '../hooks'
import { externalLinkKey } from '../keys'
import { useTantalimQuery } from '../query'
import {
  Logger,
  type ExternalLinkGetInput,
  type ExternalLinkGetSuccess,
  type ExternalLinkId,
  type ExternalLinkData,
} from '@terros/common'

const logger = new Logger('useExternalLink')
const EMPTY_EXTERNAL_LINK_ID: ExternalLinkId = 'ExternalLink.EMPTY'

export function useExternalLink(
  externalLinkId: ExternalLinkId = EMPTY_EXTERNAL_LINK_ID
): GetHookResponse<ExternalLinkData> {
  logger.verbose('calling useExternalLink', externalLinkId)
  return useTantalimQuery<ExternalLinkGetInput, ExternalLinkGetSuccess, ExternalLinkData>({
    url: '/externalLink/get',
    queryKey: externalLinkKey(externalLinkId),
    input: { externalLinkId },
    convertResponse: (data) => data.externalLink,
    options: {
      enabled: externalLinkId !== EMPTY_EXTERNAL_LINK_ID,
    },
  })
}
